import React from "react";

import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import BASESvgIcon from "../../../../../../../@BASE/core/BASESvgIcon";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Instructions from "../components/Instructions";

export default function PEPhoneCallInteraction(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>

      <Instructions
        ins={ins}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
      />

      <Typography className="text-16 font-bold p-16 pb-0">
        Page Content:
      </Typography>

      <Paper elevation={0} variant="outlined" square className="m-16 p-16">
        <Typography className="text-14 font-bold pb-0">
          Character Description:
        </Typography>
        <Divider className="my-16" />
        <Grid container xs={12}>
          <Grid item xs={12}>
            <Grid container columns={24} spacing={0.5}>
              <Grid item xs={5}>
                <Typography className="text-14 font-semibold m-0">
                  NPC Name:
                </Typography>
              </Grid>
              <Grid item xs>
                <Typography className="m-0 text-14">
                  {data.character_name}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      {data.dialog_segments.map((segment, index) => (
        <Paper
          key={index}
          elevation={0}
          variant="outlined"
          square
          className="m-16"
        >
          <Typography className="text-14 font-bold p-16 pb-0">
            Dialog Segment {index + 1}:
          </Typography>

          <Paper elevation={0} variant="outlined" square className="p-16 m-16">
            <Grid container xs={12}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  NPC Prompts:
                </Typography>
                <Divider className="my-16" />
              </Grid>
            </Grid>
            {segment.initial_prompts.map((prompt, num) => (
              <Grid key={num} container spacing={0}>
                <Grid item xs={12}>
                  <Grid container columns={24} spacing={0.5}>
                    <Grid item xs={5}>
                      <Typography className="text-14 font-semibold m-0">
                        NPC #{`${num + 1}`} Name:
                      </Typography>
                    </Grid>
                    <Grid item xs>
                      <Typography className={`${tl} m-0`} dir={dir}>
                        {prompt.user}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container columns={24} spacing={0.5}>
                    <Grid item xs={5}>
                      <Typography className="text-14 font-semibold m-0">
                        NPC {prompt.use_audio ? `Transcript` : `Prompt`}:
                      </Typography>
                    </Grid>
                    <Grid item xs>
                      <Typography
                        className={`${tl} m-0 wysiwyg`}
                        dir={dir}
                        dangerouslySetInnerHTML={{ __html: prompt.text }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Paper>

          <Paper elevation={0} variant="outlined" square className="p-16 m-16">
            <Grid container>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Initial Responses:
                </Typography>
                <Divider className="my-16" />
              </Grid>
            </Grid>
            {segment.initial_responses.map((response, num) => (
              <Grid key={num} container spacing={0}>
                <Grid item xs={12} className={num > 0 && `mt-16`}>
                  <Grid container columns={24} spacing={0.5}>
                    <Grid item xs={5}>
                      <Typography className="text-14 font-semibold m-0">
                        Learner Response{" "}
                        {response.use_audio ? `Transcript` : `Text`}:
                      </Typography>
                      {response.is_correct ? (
                        <Grid container direction="row">
                          <Typography className="text-14 font-semibold m-0">
                            Correct
                          </Typography>
                          <BASESvgIcon className="text-green-600" size={20}>
                            heroicons-solid:check-circle
                          </BASESvgIcon>
                          <Typography className="text-14 font-semibold m-0">
                            :
                          </Typography>
                        </Grid>
                      ) : (
                        <Grid container direction="row">
                          <Typography className="text-14 font-semibold m-0">
                            Incorrect
                          </Typography>
                          <BASESvgIcon className="text-red-600" size={20}>
                            heroicons-solid:x-circle
                          </BASESvgIcon>
                          <Typography className="text-14 font-semibold m-0">
                            :
                          </Typography>
                        </Grid>
                      )}
                    </Grid>
                    <Grid item xs>
                      <Typography
                        className={`${tl} m-0 wysiwyg`}
                        dir={dir}
                        dangerouslySetInnerHTML={{ __html: response.lure_text }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Paper
                    elevation={0}
                    variant="outlined"
                    square
                    className="mt-16 pb-16"
                  >
                    <Grid container spacing={0.5} className="mb-16">
                      <Grid item xs={12} className="mx-16">
                        <Typography className="text-14 font-semibold m-0 my-16">
                          NPC Feedback:
                        </Typography>
                        <Divider className="my-0" />
                      </Grid>
                    </Grid>
                    <Grid container spacing={0.5}>
                      {response.feedbacks.map((feedback, i) => (
                        <Grid
                          item
                          xs={12}
                          key={`feedback-${feedback.user}-${i}`}
                          className="mx-16"
                        >
                          {i > 0 && <Divider className="my-8" />}
                          <Grid container columns={24} spacing={0.5}>
                            <Grid item xs={5}>
                              <Typography className="text-14 font-semibold m-0">
                                NPC #{`${i + 1}`} Name:
                              </Typography>
                            </Grid>
                            <Grid item xs>
                              <Typography className={`${tl} m-0`} dir={dir}>
                                {feedback.user}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid container columns={24} spacing={0.5}>
                            <Grid item xs={5}>
                              <Typography className="text-14 font-semibold m-0">
                                NPC{" "}
                                {feedback.use_audio ? `Transcript` : `Prompt`}:
                              </Typography>
                            </Grid>
                            <Grid item xs>
                              <Typography
                                className={`${tl} m-0 wysiwyg`}
                                dir={dir}
                                dangerouslySetInnerHTML={{
                                  __html: feedback.text,
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
            ))}
          </Paper>

          <Paper elevation={0} variant="outlined" square className="p-16 m-16">
            <Grid container xs={12}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  NPC Self-Correction Prompts:
                </Typography>
                <Divider className="my-16" />
              </Grid>
            </Grid>
            {segment.self_correction_prompts.map((prompt, num) => (
              <Grid key={num} container spacing={0}>
                <Grid item xs={12}>
                  <Grid container columns={24} spacing={0.5}>
                    <Grid item xs={5}>
                      <Typography className="text-14 font-semibold m-0">
                        NPC #{`${num + 1}`} Name:
                      </Typography>
                    </Grid>
                    <Grid item xs>
                      <Typography className={`${tl} m-0`} dir={dir}>
                        {prompt.user}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container columns={24} spacing={0.5}>
                    <Grid item xs={5}>
                      <Typography className="text-14 font-semibold m-0">
                        NPC {prompt.use_audio ? `Transcript` : `Prompt`}:
                      </Typography>
                    </Grid>
                    <Grid item xs>
                      <Typography
                        className={`${tl} m-0 wysiwyg`}
                        dir={dir}
                        dangerouslySetInnerHTML={{ __html: prompt.text }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Paper>

          <Paper elevation={0} variant="outlined" square className="p-16 m-16">
            <Grid container>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Learner Self-Correction Responses:
                </Typography>
                <Divider className="my-16" />
              </Grid>
            </Grid>
            {segment.self_correction_responses.map((response, num) => (
              <Grid key={num} container spacing={0}>
                <Grid item xs={12} className={num > 0 && `mt-16`}>
                  <Grid container columns={24} spacing={0.5}>
                    <Grid item xs={5}>
                      <Typography className="text-14 font-semibold m-0">
                        Learner Response{" "}
                        {response.use_audio ? `Transcript` : `Text`}:
                      </Typography>
                      {response.is_correct ? (
                        <Grid container direction="row">
                          <Typography className="text-14 font-semibold m-0">
                            Correct
                          </Typography>
                          <BASESvgIcon className="text-green-600" size={20}>
                            heroicons-solid:check-circle
                          </BASESvgIcon>
                          <Typography className="text-14 font-semibold m-0">
                            :
                          </Typography>
                        </Grid>
                      ) : (
                        <Grid container direction="row">
                          <Typography className="text-14 font-semibold m-0">
                            Incorrect
                          </Typography>
                          <BASESvgIcon className="text-red-600" size={20}>
                            heroicons-solid:x-circle
                          </BASESvgIcon>
                          <Typography className="text-14 font-semibold m-0">
                            :
                          </Typography>
                        </Grid>
                      )}
                    </Grid>
                    <Grid item xs>
                      <Typography
                        className={`${tl} m-0 wysiwyg`}
                        dir={dir}
                        dangerouslySetInnerHTML={{ __html: response.lure_text }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Paper
                    elevation={0}
                    variant="outlined"
                    square
                    className="mt-16 pb-16"
                  >
                    <Grid container spacing={0.5} className="mb-16">
                      <Grid item xs={12} className="mx-16">
                        <Typography className="text-14 font-semibold m-0 my-16">
                          NPC Feedback:
                        </Typography>
                        <Divider className="my-0" />
                      </Grid>
                    </Grid>
                    <Grid container spacing={0.5}>
                      {response.feedbacks.map((feedback, i) => (
                        <Grid
                          item
                          xs={12}
                          key={`feedback-${feedback.user}-${i}`}
                          className="mx-16"
                        >
                          {i > 0 && <Divider className="my-8" />}
                          <Grid container columns={24} spacing={0.5}>
                            <Grid item xs={5}>
                              <Typography className="text-14 font-semibold m-0">
                                NPC #{`${i + 1}`} Name:
                              </Typography>
                            </Grid>
                            <Grid item xs>
                              <Typography className={`${tl} m-0`} dir={dir}>
                                {feedback.user}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid container columns={24} spacing={0.5}>
                            <Grid item xs={5}>
                              <Typography className="text-14 font-semibold m-0">
                                NPC{" "}
                                {feedback.use_audio ? `Transcript` : `Prompt`}:
                              </Typography>
                            </Grid>
                            <Grid item xs>
                              <Typography
                                className={`${tl} m-0 wysiwyg`}
                                dir={dir}
                                dangerouslySetInnerHTML={{
                                  __html: feedback.text,
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
            ))}
          </Paper>
        </Paper>
      ))}
    </div>
  );
}
